/* eslint-disable no-restricted-globals */
const getScreenResolution = () => {
  return `${screen.width}x${screen.height}`;
};

export default getScreenResolution;
